<template>
    <div>
        <v-card class="mt-2">
           <v-card-title class="subtitle-1">{{$t('labels.CLI_LoanDetails')}}</v-card-title>
           <v-card-text>
               <v-row col="12">
                   <v-col lg="2" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_LoanNumber')}}</span></v-row>
                       <v-row no-gutters><span>{{loanDetail.LoanNumber}}</span></v-row>
                   </v-col>
                    <v-col lg="2" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_LenderName')}}</span></v-row>
                       <v-row no-gutters class="mt-2"><span>{{loanDetail.LenderName}}</span> </v-row>
                   </v-col>
                    <v-col lg="2" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_LoanAmount')}}</span></v-row>
                       <v-row no-gutters class="mt-2"><span>{{loanDetail.LoanAmount | currency}}</span> </v-row>
                   </v-col>
                    <v-col lg="2" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_Amortization')}}</span></v-row>
                       <v-row no-gutters class="mt-2"><span>{{loanDetail.Amortization + " " + $t("labels.Months")}}</span> </v-row>
                   </v-col>
                    <v-col lg="2" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_Term')}}</span></v-row>
                       <v-row no-gutters class="mt-2"><span>{{loanDetail.Term + " " + $t("labels.Months")}}</span> </v-row>
                   </v-col>
                    <v-col lg="2" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_InterestRate')}}</span></v-row>
                       <v-row no-gutters class="mt-2"><span>{{loanDetail.InterestRate + "%"}}</span> </v-row>
                   </v-col>
               </v-row>
                <v-row col="12">   
                    <v-col lg="2" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_IssueDate')}}</span></v-row>
                       <v-row no-gutters><span>{{loanDetail.IssuedDate}}</span></v-row>
                   </v-col> 
                    <v-col lg="2" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_FundingDate')}}</span></v-row>
                       <v-row no-gutters><span>{{loanDetail.FundingDate}}</span></v-row>
                   </v-col>  
                     <v-col lg="2" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_FirstPaymentDate')}}</span></v-row>
                       <v-row no-gutters><span>{{loanDetail.FirstPaymentDate}}</span></v-row>
                   </v-col>   
                    <v-col lg="2" sm="6" md="3">
                       <v-row no-gutters><span class="font-weight-black">{{$t('labels.CLI_PaymentFrequency')}}</span></v-row>
                       <v-row no-gutters><span>{{loanDetail.PaymentFrequency}}</span></v-row>
                   </v-col>  
                    <v-col lg="4" sm="7" md="4">
                       <!-- <v-row no-gutters><span class="font-weight-black required">{{$t('labels.CLI_AcceptedDate')}}</span></v-row>
                       <v-row no-gutters>
                           <v-menu
                                v-model="dateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                 >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="acceptedDate"                                 
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    dense
                                    :rules="[v=> !!v || '']"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="acceptedDate"
                                @input="dateMenu = false"
                                :min="formatDate(min)"
                                :max="formatDate(max)"
                                ></v-date-picker>
                            </v-menu>
                        </v-row> -->
                        <v-row no-gutters><span class="font-weight-black required">{{$t('labels.CLI_PolicyEffectiveDate')}}</span></v-row>
                        <v-row no-gutters> 
                   
                      <v-select
                            v-model="loanDetail.InsuranceEffectiveType"                          
                            :items="insuranceEffectiveTypes"
                            item-text="label"
                            item-value="code"
                            :label='$t("labels.CLI_PolicyEffectiveDate")'                           
                            return-value
                            single-line
                            :rules="[v=>!!v || '']"></v-select>
                   
               </v-row>
                   </v-col>                       
               </v-row>
           </v-card-text>
       </v-card>
    </div>
</template>
<script>
export default {
     props:["loanDetail", "quoteFl"],
     data(){
         return{
              acceptedDate:"",
              dateMenu:false,
              min: new Date(2015, 0, 1),
              max: new Date(),
              insuranceEffectiveTypes: []   
         }
     },
     watch:{
       acceptedDate:function(val){
           this.loanDetail.AcceptedDate = this.acceptedDate;          
       }
     },
     created(){
       if(this.loanDetail.AcceptedDate){
           this.acceptedDate = this.loanDetail.AcceptedDate;
       }
     },
      mounted(){
        this.insuranceEffectiveTypes = [
                { label: this.$t("labels.CLI_FundingDate"), code: 'F' },
                { label: this.$t("labels.CLI_ImmediatelyUponApproval"), code: 'A' }              
            ];          
    },
     methods:{
      formatDate:function(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join('-');
     },
     }
     
}
</script>
<style scoped>
  .v-text-field{
      padding-top: 0px;  
      padding-right: 30px;       
      margin-top: 0px; 
  }
</style>